import { Component, OnInit } from '@angular/core';
import { MenuController, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-adsmodal',
  templateUrl: './adsmodal.page.html',
  styleUrls: ['./adsmodal.page.scss'],
})
export class AdsmodalPage implements OnInit {
  backdrop: any;
  adtitle: any;
  adimagename: any;
  adlink: any;
  constructor(
    private modalCtrl: ModalController,
    private menuController: MenuController
  ) {
    var adsArray = [
      [
        'Hillewaere Verzekeringen',
        'ads/hillewaere.jpg',
        'https://hillewaere-verzekeringen.be/',
      ],
      [
        'Joda Consulting',
        'ads/joda_consulting.jpg',
        'https://www.jodaconsulting.be',
      ],
      [
        'Rooselaer Car Styling',
        'ads/rooselaer.jpg',
        'https://r-carstyling.be/',
      ]
    ];
    var randomnumber = Math.floor(Math.random() * 3) + 1;
    randomnumber = randomnumber - 1;
    this.adtitle = adsArray[randomnumber][0];
    this.adimagename = adsArray[randomnumber][1];
    this.adlink = adsArray[randomnumber][2];
  }

  ngOnInit() {}
  ngOnDestroy(): void {
    this.backdrop && this.backdrop.removeAttribute('onclick');
    this.menuController.enable(true, 'sideMenu').then();
  }
  ngAfterViewInit(): void {
    this.menuController.enable(false, 'sideMenu').then();
    setTimeout(() => {
      this.addBackdropDismissClick();
    }, 0);
    var modalctr = this.modalCtrl;
    setTimeout(function () {
      modalctr.dismiss({ showAddToHome: true });
      
    }, 3000);
  }
  private addBackdropDismissClick(): void {
    this.backdrop = window.document.querySelector('.modal-wrapper');
    if (this.backdrop) {
      this.backdrop.onclick = () => {
        this.modalCtrl.dismiss({ showAddToHome: true });
      };
    }
  }
}
